import { createAction } from "typesafe-actions";

export const setBasketOpen = createAction(
  "@basket/setBasketOpen"
)<boolean>();
